import { Box, Stack, Typography } from '@mui/material';
import { usePdpPhases } from '@/api/hooks/usePdpPhases';
import { IconSvg } from '@/components/Icon';
import PhaseItem from '@/components/item/PhaseItem';
import LoadingState from '@/components/LoadingState';
import { usePdpInfo } from '@/api/hooks/usePdpInfo';
export default function PDPPhases() {
  const {
    data,
    isLoading
  } = usePdpPhases();
  const {
    data: detail
  } = usePdpInfo();
  const duration = Number(detail?.duration) ?? 0;
  const profitPerMonth = Number(detail?.profitPerMonth) ?? 0;
  const monthNames = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه', 'ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده', 'بیست', 'بیست و یک', 'بیست و دو', 'بیست و سه', 'بیست و چهار'];
  const months = [''];
  if (duration && profitPerMonth) {
    for (let i = profitPerMonth; i <= duration; i += Number(profitPerMonth)) {
      months.push(monthNames[i]);
    }
  }
  const isInProgress = data && (data?.[1]?.status === 'in_progress' || data?.[1]?.status === 'pending');
  return isLoading ? <LoadingState data-sentry-element="LoadingState" data-sentry-component="PDPPhases" data-sentry-source-file="PDPPhases.tsx" /> : <Box sx={{
    display: 'flex',
    flexDirection: 'column'
  }} data-sentry-element="Box" data-sentry-component="PDPPhases" data-sentry-source-file="PDPPhases.tsx">
      <Stack direction='row' gap={1} data-sentry-element="Stack" data-sentry-source-file="PDPPhases.tsx">
        <IconSvg component='Documents' width='32' height='32' data-sentry-element="IconSvg" data-sentry-source-file="PDPPhases.tsx" />
        <Typography sx={{
        mb: 3
      }} textAlign='left' variant='headlineStrong__Wallfund' color='text.text' id='section-4' data-sentry-element="Typography" data-sentry-source-file="PDPPhases.tsx">
          زمان‌بندی طرح
        </Typography>
      </Stack>

      {(data || []).map((item, idx) => {
      if (idx > 1 && isInProgress && item.isProfit) {
        item.startDateDesc = `${months[idx - 2] ?? 0} ماه پس از موفقیت طرح`;
      } else if (idx === 1 && isInProgress) {
        item.startDateDesc = 'در حال انجام';
      }
      return <PhaseItem key={'item_phase' + idx} data={item} index={idx} />;
    })}
    </Box>;
}